import "@fontsource/inter/400.css"; // Regular weight
import "@fontsource/inter/600.css"; // Regular weight
import "@fontsource/inter/700.css"; // Bold weight
import "@fontsource/inter/800.css"; // Extra bold weight

import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";

export const typography = {
  fontFamily: "Montserrat",
  fontStyle: "normal",

  // H E A D E R
  h1ExtraBold: {
    component: "h1",
    fontFamily: "Montserrat",
    fontSize: "32px",
    fontWeight: 800,
    lineHeight: "normal",
  },
  h2ExtraBold: {
    component: "h2",
    fontFamily: "Montserrat",
    fontSize: "28px",
    fontWeight: 800,
    lineHeight: "normal",
  },
  h3ExtraBold: {
    component: "h3",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontWeight: 800,
    lineHeight: "normal",
  },
  h3Bold: {
    component: "h3",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "130%",
  },
  h4ExtraBold: {
    component: "h4",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontWeight: 800,
    lineHeight: "normal",
  },
  h5Bold: {
    component: "h5",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "normal",
  },
  // B O D Y
  body16ExtraBold: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 800,
    lineHeight: "22px",
  },
  body16Bold: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "normal",
  },
  body16SemiBold: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
  },
  body16Regular: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "150%",
  },
  body14Bold: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "normal",
  },
  body14SemiBold: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
  },
  body14Regular: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "24px",
  },
  capsLock14ExtraBold: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: "normal",
    textTransform: "uppercase" as "uppercase",
  },
  body13Bold: {
    fontFamily: "Montserrat",
    fontSize: "13px",
    fontWeight: 700,
    lineHeight: "16px",
  },
  body13Regular: {
    fontFamily: "Montserrat",
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "normal",
  },
  body12Bold: {
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "normal",
  },
  body12SemiBold: {
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "normal",
  },
  body12Regular: {
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "normal",
  },
  body10Bold: {
    fontFamily: "Montserrat",
    fontSize: "10px",
    fontWeight: 700,
    lineHeight: "normal",
  },
  body10SemiBold: {
    fontFamily: "Montserrat",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "normal",
  },
  body10Regular: {
    fontFamily: "Montserrat",
    fontSize: "10px",
    fontWeight: 400,
    lineHeight: "normal",
  },

  // Old Typography to be removed
  h1: {
    fontSize: "1.75rem", // 28px
    fontWeight: 800,
    // Use for main page titles
  },
  h2: {
    fontSize: "1.5rem", // 24px
    fontWeight: 800,
    // Use for secondary titles
  },
  h3: {
    fontSize: "1.375rem", // 22px
    fontWeight: 800,
    // Use for section headings
  },
  h4: {
    fontSize: "1.25rem", // 20px
    fontWeight: 700,
    // Use for subsection headings
  },
  h5: {
    fontSize: "1.125rem", // 18px
    fontWeight: 700,
    // Use for minor headings
  },
  h6: {
    fontSize: "1.25rem", // 20px
    fontWeight: 700,
    // Use for less prominent headings
  },
  subtitle1: {
    fontSize: "1rem", // 16px
    fontWeight: 700,
  },
  body1: {
    fontSize: "1rem", // 16px
    fontWeight: 400,
    // Use for main body text
  },
  body2: {
    fontSize: "0.875rem", // 14px
    fontWeight: 400,
    // Use for secondary body text
  },
  button: {
    fontSize: "0.875rem", // 14px
    fontWeight: 700,
    // Use for button text
  },
  input: {
    fontSize: "0.875rem", // 14px
    fontWeight: 400,
    // Add any other styles for input elements
  },
};

export default typography;
